/* Auto light/dark header + product colour rail.
   Store-wide: on every template the header ink is a function of the scroll.
   Whatever shows through the frosted bar decides — a pale ground keeps the ink
   brown, a dark or colour-heavy ground turns the logo and every label white. */
(function () {
  var header = document.querySelector('.header');
  if (!header) return;
  var FLIP = 0.58;   /* weighted luminance below this reads as dark ground */
  var HYST = 0.05;   /* dead band, so a borderline ground cannot flicker */
  var decoded = {};
  var lumCache = {};

  (function injectCss() {
    if (document.getElementById('header-tone-css')) return;
    var s = document.createElement('style');
    s.id = 'header-tone-css';
    /* Scoped to the bar's own rows (.header__row / .navrow) and applied to every
       descendant, so MENU, the currency select, the bag counter and the icons
       always change together. The mega panels live elsewhere inside <header> and
       are deliberately left alone. */
    s.textContent =
      '.header[data-tone="dark"] .header__row,.header[data-tone="dark"] .header__row *,' +
      '.header[data-tone="dark"] .navrow,.header[data-tone="dark"] .navrow *{' +
        'color:var(--header-transparent-text,#fff)!important;' +
        '-webkit-text-fill-color:var(--header-transparent-text,#fff)!important}' +
      '.header[data-tone="dark"] .header__row svg,.header[data-tone="dark"] .navrow svg{' +
        'stroke:var(--header-transparent-text,#fff)!important}' +
      '.header[data-tone="light"] .header__row,.header[data-tone="light"] .header__row *,' +
      '.header[data-tone="light"] .navrow,.header[data-tone="light"] .navrow *{' +
        'color:var(--ink,#0b0b0a)!important;-webkit-text-fill-color:var(--ink,#0b0b0a)!important}' +
      '.header[data-tone="light"] .header__row svg,.header[data-tone="light"] .navrow svg{' +
        'stroke:var(--ink,#0b0b0a)!important}' +
      '.header__logo{transition:opacity .2s ease,filter .2s ease}' +
      '.header[data-tone] .header__row option{color:var(--ink,#0b0b0a)!important;' +
        '-webkit-text-fill-color:var(--ink,#0b0b0a)!important}';
    (document.head || document.documentElement).appendChild(s);
  })();

  function lum(r, g, b) { return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255; }

  function forcedWhite() {
    return document.body && document.body.hasAttribute('data-force-white');
  }

  function parse(c) {
    var m = (c || '').match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var p = m[1].split(/[,\s\/]+/).filter(function (s) { return s !== ''; }).map(parseFloat);
    if (p.length < 3 || isNaN(p[0])) return null;
    return { r: p[0], g: p[1], b: p[2], a: p.length > 3 && !isNaN(p[3]) ? p[3] : 1 };
  }

  function headerBg() {
    return parse(getComputedStyle(header).backgroundColor) || { r: 255, g: 255, b: 255, a: 0 };
  }

  /* A page can opt out with --tone-behind:0 on .header. */
  function glass() {
    var v = getComputedStyle(header).getPropertyValue('--tone-behind');
    return !(v && parseFloat(v) === 0);
  }

  function spillPx() {
    var n = parseFloat(getComputedStyle(header).getPropertyValue('--glass-blur'));
    if (isNaN(n)) n = 20;
    return Math.max(36, Math.min(80, n * 2.5));
  }

  function getImage(src) {
    if (src in decoded) return decoded[src] === 'pending' ? null : decoded[src];
    decoded[src] = 'pending';
    var i = new Image();
    i.crossOrigin = 'anonymous';
    i.onload = function () { decoded[src] = i; update(true); };
    i.onerror = function () { decoded[src] = null; };
    i.src = src;
    return null;
  }

  function stripLum(src, t0, t1, xFrac) {
    var key = src + '|' + Math.round(t0 * 20) + '|' + Math.round(t1 * 20) + '|' + Math.round(xFrac * 4);
    if (key in lumCache) return lumCache[key];
    var im = getImage(src);
    if (!im) return null;
    var N = 64, out = null;
    try {
      var c = document.createElement('canvas');
      c.width = N; c.height = N;
      var x = c.getContext('2d');
      x.drawImage(im, 0, 0, N, N);
      var y0 = Math.max(0, Math.floor(t0 * N));
      var y1 = Math.min(N, Math.max(y0 + 1, Math.ceil(t1 * N)));
      var x0 = Math.max(0, Math.floor((xFrac - 0.2) * N));
      var x1 = Math.min(N, Math.max(x0 + 1, Math.ceil((xFrac + 0.2) * N)));
      var d = x.getImageData(x0, y0, x1 - x0, y1 - y0).data, t = 0, n = 0;
      for (var k = 0; k < d.length; k += 4) { t += lum(d[k], d[k + 1], d[k + 2]); n++; }
      out = n ? t / n : null;
    } catch (e) { out = 0.3; }
    lumCache[key] = out;
    return out;
  }

  function bandFractions(rect, band) {
    if (!rect.height) return null;
    var t0 = Math.max(0, Math.min(1, (band.top - rect.top) / rect.height));
    var t1 = Math.max(0, Math.min(1, (band.bottom - rect.top) / rect.height));
    if (t1 - t0 < 0.02) { t0 = 0; t1 = 0.12; }
    return [t0, t1];
  }

  function behindAt(x, y, band) {
    var els = document.elementsFromPoint(x, y) || [];
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el === header || header.contains(el)) continue;
      if (el.hasAttribute && el.hasAttribute('data-header-tone')) {
        return el.getAttribute('data-header-tone') === 'dark' ? 0 : 1;
      }
      var r = el.getBoundingClientRect();
      var f = bandFractions(r, band);
      var xf = r.width ? (x - r.left) / r.width : 0.5;
      if (el.tagName === 'IMG') {
        var src = el.currentSrc || el.src;
        return src && f ? stripLum(src, f[0], f[1], xf) : null;
      }
      if (el.tagName === 'VIDEO') return 0.28;
      var cs = getComputedStyle(el);
      if (cs.backgroundImage && cs.backgroundImage !== 'none') {
        var u = cs.backgroundImage.match(/url\(["']?([^"')]+)/);
        if (u && f) return stripLum(u[1], f[0], f[1], xf);
        return 0.3;
      }
      var bg = parse(cs.backgroundColor);
      if (bg && bg.a >= 0.5) return lum(bg.r, bg.g, bg.b);
    }
    return null;
  }

  /* What the frosted bar visually carries: the strip under it (counted double,
     it is what sits right behind the type) plus the blur spill from just below
     its bottom edge. */
  function readBand() {
    var r = header.getBoundingClientRect();
    var spill = spillPx();
    var band = { top: r.top, bottom: r.bottom + spill };
    var W = window.innerWidth;
    var rows = [
      { y: r.top + r.height * 0.3, w: 2 },
      { y: r.top + r.height * 0.7, w: 2 },
      { y: r.bottom + spill * 0.3, w: 1 },
      { y: r.bottom + spill * 0.8, w: 1 }
    ];
    var xs = [0.06, 0.16, 0.3, 0.42, 0.5, 0.58, 0.7, 0.84, 0.94].map(function (f) { return W * f; });
    var sum = 0, weight = 0, vals = [];
    for (var j = 0; j < rows.length; j++) {
      var y = Math.max(1, Math.min(window.innerHeight - 2, rows[j].y));
      for (var i = 0; i < xs.length; i++) {
        var v = behindAt(xs[i], y, band);
        if (v == null) continue;
        vals.push(v);
        sum += v * rows[j].w;
        weight += rows[j].w;
      }
    }
    return { rect: r, vals: vals, mean: weight ? sum / weight : null };
  }

  function toneAt(previous) {
    if (forcedWhite()) return 'dark';
    var read = readBand();
    if (read.rect.bottom <= 0) return null;
    var hb = headerBg();
    var ha = Math.max(0, Math.min(1, hb.a));
    var hl = lum(hb.r, hb.g, hb.b);
    if (!glass() && ha >= 0.92) return hl < FLIP ? 'dark' : 'light';

    var mean = read.mean;
    if (mean == null) return hl < FLIP ? 'dark' : 'light';
    /* Straight weighted average of the ground: a mostly pale shot with a couple
       of dark garments stays brown, a genuinely dark or saturated ground goes
       white. The dead band keeps a borderline ground from flickering. */
    if (previous === 'dark') return mean > FLIP + HYST ? 'light' : 'dark';
    if (previous === 'light') return mean < FLIP - HYST ? 'dark' : 'light';
    return mean < FLIP ? 'dark' : 'light';
  }

  var raf = null, last = null;
  var lastRun = 0;
  var MIN_INTERVAL = 50;
  var settleTimer = null;

  function applyLogos(tone) {
    var brand = header.querySelector('.header__brand');
    if (!brand) return;
    var logos = [].slice.call(brand.querySelectorAll('.header__logo'));
    if (!logos.length) return;
    var inverse = brand.querySelector('.header__logo--inverse');
    var mobile = brand.querySelector('.header__logo--mobile');
    var solid = logos.filter(function (el) { return el !== inverse && el !== mobile; })[0];
    var isMobile = window.innerWidth <= 749;
    var base = (isMobile && mobile) || solid || logos[0];
    var target = tone === 'dark' ? (inverse || base) : base;
    logos.forEach(function (el) {
      el.style.setProperty('display', el === target ? 'block' : 'none', 'important');
      if (tone === 'dark' && el === target && el !== inverse) {
        el.style.setProperty('filter', 'brightness(0) invert(1)', 'important');
      } else {
        el.style.removeProperty('filter');
      }
      el.style.removeProperty('opacity');
      el.style.removeProperty('visibility');
    });
  }

  function scheduleSettle() {
    if (settleTimer) clearTimeout(settleTimer);
    settleTimer = setTimeout(function () { settleTimer = null; update(true); }, 140);
  }

  function update(force) {
    var now = Date.now ? Date.now() : new Date().getTime();
    if (!force && now - lastRun < MIN_INTERVAL) { scheduleSettle(); return; }
    lastRun = now;
    var t = toneAt(last);
    if (!t) return;
    if (forcedWhite()) t = 'dark';
    if (t !== last) { last = t; header.setAttribute('data-tone', t); }
    applyLogos(t);
  }

  window.mdHeaderTone = function () { update(true); };
  /* Diagnostics: mdHeaderToneReport() in the console shows what the bar read. */
  window.mdHeaderToneReport = function () {
    var read = readBand();
    return {
      tone: header.getAttribute('data-tone'),
      mean: read.mean == null ? null : +read.mean.toFixed(3),
      flipsBelow: FLIP,
      samples: read.vals.length,
      values: read.vals.map(function (v) { return +v.toFixed(2); }),
      forcedWhite: forcedWhite()
    };
  };

  function onScroll() {
    scheduleSettle();
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = null; update(); });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('scrollend', function () { update(true); });
  window.addEventListener('wheel', scheduleSettle, { passive: true });
  window.addEventListener('touchmove', scheduleSettle, { passive: true });
  window.addEventListener('touchend', scheduleSettle, { passive: true });
  window.addEventListener('resize', onScroll);
  header.addEventListener('transitionend', function (e) { if (e.target === header) update(true); });
  window.addEventListener('load', function () { update(true); });
  document.addEventListener('shopify:section:load', function () { update(true); });
  document.addEventListener('shopify:section:select', function () { update(true); });
  document.addEventListener('DOMContentLoaded', function () { update(true); });
  update(true);
  setTimeout(function () { update(true); }, 300);
  setTimeout(function () { update(true); }, 1200);
})();

/* Product colour rail: turns the colour-family thumbnails into a slider with a scroll
   indicator and a More colours dropdown (only shown with more than 6 colours). */
(function () {
  function init() {
    var info = document.querySelector('.pdp__inner');
    if (!info || info.hasAttribute('data-crail-done')) return;
    var links = [].slice.call(info.querySelectorAll('a[aria-current]')).filter(function (a) { return a.querySelector('img'); });
    if (links.length < 2) return;
    var rail = links[0].parentElement;
    var wrap = rail && rail.parentElement;
    if (!rail || !wrap) return;
    info.setAttribute('data-crail-done', '');

    var css = document.createElement('style');
    css.textContent =
      '.crail{overflow-x:auto;flex-wrap:nowrap!important;scroll-snap-type:x proximity;scrollbar-width:none;-ms-overflow-style:none}' +
      '.crail::-webkit-scrollbar{display:none}' +
      '.crail>a{flex:0 0 auto;scroll-snap-align:start;transition:border-color .18s ease,opacity .18s ease}' +
      '.crail>a:hover{opacity:.86}' +
      '.crail-bar{position:relative;height:1px;background:var(--line,#e4ded3);margin-top:11px}' +
      '.crail-bar>span{position:absolute;left:0;top:-1px;height:3px;background:var(--ink,#0b0b0a);transition:transform .1s linear,width .1s linear}' +
      '.crail-top{display:flex;justify-content:space-between;align-items:baseline;gap:12px}' +
      '.crail-more{position:relative}' +
      '.crail-more>summary{list-style:none;cursor:pointer;font:400 9.5px/1 var(--mono,ui-monospace,Menlo,monospace);letter-spacing:.16em;text-transform:uppercase;border-bottom:1px solid currentColor;padding-bottom:3px;white-space:nowrap}' +
      '.crail-more>summary::-webkit-details-marker{display:none}' +
      '.crail-panel{position:absolute;right:0;top:calc(100% + 10px);z-index:30;background:var(--bg,#fff);border:var(--border,1px) solid var(--line,#e4ded3);min-width:230px;max-height:290px;overflow:auto;padding:5px 0;box-shadow:0 20px 44px rgba(0,0,0,.10)}' +
      '.crail-panel a{display:flex;gap:11px;align-items:center;padding:9px 14px;font:400 10.5px/1.2 var(--mono,ui-monospace,Menlo,monospace);letter-spacing:.06em;text-transform:uppercase;text-decoration:none;color:inherit}' +
      '.crail-panel a:hover{background:var(--paper,#f4f0e9)}' +
      '.crail-panel a[data-current]{opacity:.45}' +
      '.crail-panel i{width:17px;height:21px;flex:0 0 auto;background-size:cover;background-position:center;border:var(--border,1px) solid var(--line,#e4ded3)}' +
      '@media (max-width:860px){.pdp__thumbs{padding:0 var(--gutter,18px);background:transparent;gap:6px}}' +
      '.crail.is-dragging{user-select:none}';
    document.head.appendChild(css);

    rail.classList.add('crail');

    var label = wrap.querySelector('.label');
    var top = document.createElement('div');
    top.className = 'crail-top';
    wrap.insertBefore(top, rail);
    if (label) top.appendChild(label);

    if (links.length > 6) {
      var det = document.createElement('details');
      det.className = 'crail-more';
      var sum = document.createElement('summary');
      sum.textContent = 'More colours';
      det.appendChild(sum);
      var panel = document.createElement('div');
      panel.className = 'crail-panel';
      links.forEach(function (a) {
        var img = a.querySelector('img');
        var row = document.createElement('a');
        row.href = a.getAttribute('href');
        if (a.getAttribute('aria-current') === 'true') row.setAttribute('data-current', '');
        var sw = document.createElement('i');
        if (img) sw.style.backgroundImage = 'url(' + (img.currentSrc || img.src) + ')';
        var name = document.createElement('span');
        name.textContent = a.getAttribute('title') || (img && img.alt) || 'Colour';
        row.appendChild(sw);
        row.appendChild(name);
        panel.appendChild(row);
      });
      det.appendChild(panel);
      top.appendChild(det);
      document.addEventListener('click', function (e) {
        if (det.hasAttribute('open') && !det.contains(e.target)) det.removeAttribute('open');
      });
    }

    var barWrap = document.createElement('div');
    barWrap.className = 'crail-bar';
    var bar = document.createElement('span');
    barWrap.appendChild(bar);
    rail.insertAdjacentElement('afterend', barWrap);

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      if (max < 4) { barWrap.style.display = 'none'; return; }
      barWrap.style.display = '';
      var ratio = rail.clientWidth / rail.scrollWidth;
      var w = Math.max(12, ratio * 100);
      bar.style.width = w + '%';
      bar.style.transform = 'translateX(' + ((rail.scrollLeft / max) * (100 - w) / w * 100) + '%)';
    }
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    /* Desktop: let a mouse scroll the rail. The scrollbar is hidden, so without
       this only a trackpad or Shift+wheel could reach the colours past the edge. */
    var snapTimer = null;
    function pauseSnap() {
      if (snapTimer) { clearTimeout(snapTimer); snapTimer = null; }
      if (!rail.hasAttribute('data-snap-paused')) {
        rail.setAttribute('data-snap-paused', rail.style.getPropertyValue('scroll-snap-type') || '');
        rail.style.setProperty('scroll-snap-type', 'none', 'important');
      }
    }
    function resumeSnap(delay) {
      if (snapTimer) clearTimeout(snapTimer);
      snapTimer = setTimeout(function () {
        snapTimer = null;
        if (!rail.hasAttribute('data-snap-paused')) return;
        var prev = rail.getAttribute('data-snap-paused');
        rail.removeAttribute('data-snap-paused');
        if (prev) rail.style.setProperty('scroll-snap-type', prev, 'important');
        else rail.style.removeProperty('scroll-snap-type');
      }, delay || 0);
    }

    /* Mouse wheel: scroll sideways while the rail can still move, then hand the
       wheel back to the page at either end. Trackpad sideways swipes and
       ctrl+wheel zoom are left to the browser. */
    rail.addEventListener('wheel', function (e) {
      if (e.ctrlKey) return;
      var max = rail.scrollWidth - rail.clientWidth;
      if (max < 4) return;
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      var d = e.deltaY * (e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? rail.clientWidth : 1);
      if ((d < 0 && rail.scrollLeft <= 0) || (d > 0 && rail.scrollLeft >= max - 1)) return;
      e.preventDefault();
      pauseSnap();
      rail.scrollLeft += d;
      resumeSnap(180);
    }, { passive: false });

    /* Click and drag with a mouse. Touch keeps its native swipe. */
    var drag = null, dragged = false;
    rail.addEventListener('pointerdown', function (e) {
      dragged = false;
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (rail.scrollWidth - rail.clientWidth < 4) return;
      drag = { x: e.clientX, left: rail.scrollLeft, id: e.pointerId };
    });
    rail.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      if (!dragged && Math.abs(dx) < 5) return;
      if (!dragged) {
        dragged = true;
        rail.classList.add('is-dragging');
        try { rail.setPointerCapture(drag.id); } catch (err) {}
        pauseSnap();
      }
      rail.scrollLeft = drag.left - dx;
    });
    function endDrag(e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      drag = null;
      if (dragged) { rail.classList.remove('is-dragging'); resumeSnap(0); }
    }
    rail.addEventListener('pointerup', endDrag);
    rail.addEventListener('pointercancel', endDrag);
    rail.addEventListener('lostpointercapture', endDrag);
    /* A drag that ends over a swatch must not open that colour. */
    rail.addEventListener('click', function (e) {
      if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; }
    }, true);
    /* Stop the browser dragging the swatch image or link instead of the rail. */
    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });

    var active = links.filter(function (a) { return a.getAttribute('aria-current') === 'true'; })[0];
    if (active) rail.scrollLeft = Math.max(0, active.offsetLeft - rail.clientWidth / 2 + active.offsetWidth / 2);
    sync();
    setTimeout(sync, 400);
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);
  init();
})();